import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.94903 4.125L0.000488281 7.06588H20.3608L19.2358 10.4424H11.0961L10.2799 12.8169H18.5299L17.2505 16.8034H5.71373L8.16226 9.61463L5.47108 7.65405L1.54461 19.875H16.2578L20.052 18.0016L21.3093 13.7972L18.8608 11.8584L22.6549 10.0503L24.0005 6.10737L21.3093 4.125H3.94903Z"
      fill="#FDFE00"
    />
  </svg>
)
